export const CommonData = () => {
  const AwardYear = "2026";
  const DigitalTeamMail = "digitalteam@nfdcindia.com";
  const DigitalTeamPhone = "+91-1124369462";
  return {
    year: AwardYear,
    DigitalMail: DigitalTeamMail,
    DigitalPhon: DigitalTeamPhone,
  };
};
export const IpData = () => {
  const IpLastDate = "11th August, 2026";
  const IpLastTime = "6:00 PM";
  const IpLastDocumentDate = "26th August, 2026";
  const IpLastDocumentTime = "6:00 PM";
  const IpassistanceNum = "022-23533275 / 20830471";
  const IpassistanceMail = "indianpanorama@nfdcindia.com";
  return {
    IpLastDate,
    IpLastTime,
    IpLastDocumentDate,
    IpLastDocumentTime,
    IpassistanceNum,
    IpassistanceMail,
  };
};
export const OttData = () => {
  const ottLastSubmissionDate = "11th August, 2026";
  const ottLastSubmissionTime = "6:00 PM";
  const ottLastDocumentDate = "16th August, 2026";
  const ottLastDocumentTime = "6:00 PM";
  const ottMailAward = "webseriesaward@gmail.com";
  const ottassistanceNum = "022-23533275 / 20830471";

  return {
    OttSubDate: ottLastSubmissionDate,
    OttSubTime: ottLastSubmissionTime,
    OttDocDate: ottLastDocumentDate,
    OttDocTime: ottLastDocumentTime,
    OttMail: ottMailAward,
    OttNum: ottassistanceNum,
  };
};
export const CmotData = () => {
  const CmotOnlineSubmitt = "22th September, 2026";
  return {
    CmotOnlineSubmitt,
  };
};
export const DdData = () => {
  const DdLastDocumentDate = "30th September, 2026";
  const DdassistanceMail = "bestdebut@nfdcindia.com";
  const DdOnlineSubmitt = "25th September, 2026";
  return {
    DdLastDocumentDate,
    DdassistanceMail,
    DdOnlineSubmitt,
  };
};
